import { differenceInCalendarDays } from 'date-fns'
import { CalendarCheckIcon, CalendarIcon } from 'lucide-react'

import { Badge, Tooltip } from 'slab'
import { formatInvoiceDate } from 'utils/billing'
import { type EmployersTodo } from 'utils/web_api.schemas'

function formatDaysUntilDue (daysUntilDue: number): string {
  if (daysUntilDue === 0) {
    return 'Due today'
  } else if (daysUntilDue === 1) {
    return 'Due tomorrow'
  } else if (daysUntilDue > 1) {
    return `Due in ${daysUntilDue} days`
  } else if (daysUntilDue === -1) {
    return 'Overdue by 1 day'
  } else {
    return `Overdue by ${Math.abs(daysUntilDue)} days`
  }
}

export default function DueDateOrCompletionBadge ({ todo }: { todo: EmployersTodo }) {
  const currentDate = new Date()
  const dueDate = todo.deadline ? new Date(todo.deadline) : null
  const isCompleted = todo.status === 'completed'

  if (isCompleted) {
    return (
      <div className='flex-shrink-0 body-sm flex items-center gap-1'>
        <CalendarCheckIcon className='text-green-400' size={12} />
        <span className='text-green-400'>
          Completed {formatInvoiceDate(new Date(todo.completed_at!))}{todo.completed_by && ` by ${todo.completed_by}`}
        </span>
      </div>
    )
  }

  if (!dueDate) {
    return <></>
  }

  const daysUntilDue = differenceInCalendarDays(dueDate, currentDate)
  const dueDateLabel = formatDaysUntilDue(daysUntilDue)
  const fullDateLabel = formatInvoiceDate(dueDate.toISOString())

  if (daysUntilDue >= 7) {
    return (
      <Tooltip content={fullDateLabel} side='bottom'>
        <div className='flex items-center gap-1'>
          <CalendarIcon className='text-gray-500' size={16} />
          <span className='text-gray-500 body-sm'>{dueDateLabel}</span>
        </div>
      </Tooltip>
    )
  } else {
    const badgeType = daysUntilDue >= 3 ? 'caution' : 'critical'
    return (
      <Tooltip content={fullDateLabel} side='bottom'>
        <Badge type={badgeType} bordered>
          {dueDateLabel}
        </Badge>
      </Tooltip>
    )
  }
}
